export const EVENT_COLLAPSE_MIN_LIMIT = 5;
export const TICKET_LIMIT = 25;
export const ADD_TO_CART_ACTION_RESULT = 'addToCart';
export const CASH = 1;
export const CARD = 2;
export const ZERO_PRICE = 3;
export const TICKETS_SHOW_EXACT_NUMBER_LIMIT = 20;
export const MAX_TICKETS_IN_CART = 500;
export const CONTINUE_WITHOUT_SAVING = 'continueWithoutSaving';
export const TO_EVENT_ACTION = 'toEvent';
export const TO_EVENT_BO_VIEW = 'toSelfServiceEvent';
export const UUID_LENGTH = 36;
export const MAX_TICKETS_IN_EMAIL = 30;
export const STORAGE_PROMOCODE_STORAGE = 'promocode.storage';
